var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      _vm._l(_vm.visits.data, function(item, index) {
        return _c(
          "div",
          { key: "register-visit" + index },
          [
            _c(
              "validation-observer",
              {
                ref: "registerVisitForm",
                refInFor: true,
                attrs: { novalidate: "", tag: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.handleSaveVisit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "custom-callout",
                  {
                    staticClass: "mb-3 custom-callout",
                    attrs: { controlled: true, opened: item.isOpen },
                    on: {
                      "click:open": function($event) {
                        return _vm.onToggleAdditionalInfo(item, index)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "edition",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "bg-secondary-9 p-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-panel bg-white rounded pb-3"
                                  },
                                  [
                                    _c(
                                      "b-tabs",
                                      {
                                        attrs: {
                                          "active-nav-item-class":
                                            "mipe-tab font-weight-bold text-green active-nav-item-custom",
                                          "active-tab-class": "",
                                          "content-class": "mt-3",
                                          "nav-class": "custom-nav-container",
                                          "no-nav-style": true
                                        }
                                      },
                                      [
                                        _c(
                                          "b-tab",
                                          {
                                            attrs: {
                                              active:
                                                item.selectedTab ==
                                                _vm.additionalInfoTabs
                                                  .REPLACE_SPECIALIST,
                                              title:
                                                "Reemplazar Maestro / Asistente de Servicios"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row mx-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-6" },
                                                  [
                                                    _c("checkbox", {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        disabled:
                                                          item.saved &&
                                                          !item.isReplaceSpecialistVisible,
                                                        text: "Maestro:"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.onChangeSelectedTeacherSpecialist(
                                                            item.selectedTeacherSpecialistOption,
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.selectedTeacherSpecialistOption,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "selectedTeacherSpecialistOption",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.selectedTeacherSpecialistOption"
                                                      }
                                                    }),
                                                    _c("custom-drop-down", {
                                                      attrs: {
                                                        disabled:
                                                          (item.saved &&
                                                            !item.isReplaceSpecialistVisible) ||
                                                          !item.selectedTeacherSpecialistOption,
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        options:
                                                          _vm.teacherSpecialists,
                                                        placeholder:
                                                          "Seleccione"
                                                      },
                                                      model: {
                                                        value:
                                                          item.selectedTeacherSpecialist,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "selectedTeacherSpecialist",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.selectedTeacherSpecialist"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-md-6" },
                                                  [
                                                    _c("checkbox", {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        disabled:
                                                          item.saved &&
                                                          !item.isReplaceSpecialistVisible,
                                                        text:
                                                          "Asistente de Servicio:"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.onChangeSelectedAssistanceServiceSpecialist(
                                                            item.selectedAssistanceServiceSpecialistOption,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.selectedAssistanceServiceSpecialistOption,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "selectedAssistanceServiceSpecialistOption",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "\n                            item.selectedAssistanceServiceSpecialistOption\n                          "
                                                      }
                                                    }),
                                                    _c("custom-drop-down", {
                                                      attrs: {
                                                        disabled:
                                                          (item.saved &&
                                                            !item.isReplaceSpecialistVisible) ||
                                                          !item.selectedAssistanceServiceSpecialistOption,
                                                        fieldkey: "id",
                                                        fieldname: "name",
                                                        options:
                                                          _vm.assistanceServiceSpecialists,
                                                        placeholder:
                                                          "Seleccione"
                                                      },
                                                      model: {
                                                        value:
                                                          item.selectedAssistanceServiceSpecialist,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "selectedAssistanceServiceSpecialist",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.selectedAssistanceServiceSpecialist"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row align-items-center no-gutters" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-1 col-spacing" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-6 font-weight-normal font-14"
                              },
                              [_vm._v(" Día: ")]
                            ),
                            !item.saved
                              ? _c("validation-provider", {
                                  attrs: { name: "Día", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-input", {
                                              staticClass: "hour-size",
                                              attrs: {
                                                "custom-error-msg": "",
                                                error: errors[0],
                                                "mask-type": "Day",
                                                type: "text"
                                              },
                                              model: {
                                                value: item.day,
                                                callback: function($$v) {
                                                  _vm.$set(item, "day", $$v)
                                                },
                                                expression: "item.day"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _c("span", { staticClass: "color-black" }, [
                                  _vm._v(_vm._s(item.day))
                                ])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-3 col-spacing" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-6 font-weight-normal font-14"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.saved ? "Hora:" : "Hora Desde:"
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            !item.saved
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "HourStartHour",
                                        rules: "required"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass: "hour-size",
                                                  attrs: {
                                                    "custom-error-msg": "",
                                                    error: errors[0],
                                                    "mask-type": "Day",
                                                    type: "text"
                                                  },
                                                  model: {
                                                    value: item.hourStartHour,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "hourStartHour",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.hourStartHour"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _c("span", { staticClass: "mx-1" }, [
                                      _vm._v(":")
                                    ]),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "HourStartMinute",
                                        rules: "required"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass: "hour-size",
                                                  attrs: {
                                                    "custom-error-msg": "",
                                                    error: errors[0],
                                                    "mask-type": "Day",
                                                    type: "text"
                                                  },
                                                  model: {
                                                    value: item.hourStartMinute,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "hourStartMinute",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.hourStartMinute"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _c("b-form-select", {
                                      staticClass: "ampm-size ml-1",
                                      attrs: { options: _vm.timeOptions },
                                      model: {
                                        value: item.hourStartTime,
                                        callback: function($$v) {
                                          _vm.$set(item, "hourStartTime", $$v)
                                        },
                                        expression: "item.hourStartTime"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("span", { staticClass: "color-black" }, [
                                  _vm._v(_vm._s(_vm.getHourRange(item)))
                                ])
                          ]
                        ),
                        !item.saved
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-md-3 col-spacing" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-secondary-6 font-weight-normal font-14"
                                  },
                                  [_vm._v(" Hora Hasta: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "hourEnd",
                                        rules: "required"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass: "hour-size",
                                                  attrs: {
                                                    "custom-error-msg": "",
                                                    error: errors[0],
                                                    "mask-type": "Day",
                                                    type: "text"
                                                  },
                                                  model: {
                                                    value: item.hourEnd,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "hourEnd",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.hourEnd"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _c("span", { staticClass: "mx-1" }, [
                                      _vm._v(":")
                                    ]),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "hourEndMinute",
                                        rules: "required"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  staticClass: "hour-size",
                                                  attrs: {
                                                    "custom-error-msg": "",
                                                    error: errors[0],
                                                    "mask-type": "Day",
                                                    type: "text"
                                                  },
                                                  model: {
                                                    value: item.hourEndMinute,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "hourEndMinute",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.hourEndMinute"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _c("b-form-select", {
                                      staticClass: "ampm-size ml-1",
                                      attrs: { options: _vm.timeOptions },
                                      model: {
                                        value: item.hourEndTime,
                                        callback: function($$v) {
                                          _vm.$set(item, "hourEndTime", $$v)
                                        },
                                        expression: "item.hourEndTime"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 col-spacing",
                            class: item.saved ? "col-md-5" : "col-md-3"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-6 font-weight-normal font-14"
                              },
                              [_vm._v(" Tipo: ")]
                            ),
                            !item.saved
                              ? _c(
                                  "span",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "SelectedType",
                                        rules: "required"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("CustomDropDown", {
                                                  attrs: {
                                                    disabled: item.id,
                                                    error: errors[0],
                                                    fieldkey: "id",
                                                    fieldname: "name",
                                                    options: _vm.visitTypes
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.handleChangeVisitType
                                                  },
                                                  model: {
                                                    value: item.selectedType,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "selectedType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.selectedType"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    item.selectedType &&
                                    item.selectedType.showPreviousYears
                                      ? _c(
                                          "div",
                                          { staticClass: "mt-2" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-secondary-6 font-weight-normal font-14"
                                              },
                                              [_vm._v(" Año Anterior: ")]
                                            ),
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("CustomDropDown", {
                                                          attrs: {
                                                            error: errors[0],
                                                            fieldkey: "id",
                                                            fieldname:
                                                              "description",
                                                            options:
                                                              _vm.compensatoryYears
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleChangeCompensatoryYear(
                                                                item
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              item.previousAcademicYear,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "previousAcademicYear",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.previousAcademicYear"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.selectedType &&
                                    item.previousAcademicYear &&
                                    item.previousAcademicYear.id > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "mt-2" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-secondary-6 font-weight-normal font-14"
                                              },
                                              [_vm._v(" Solicitud: ")]
                                            ),
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("CustomDropDown", {
                                                          attrs: {
                                                            error: errors[0],
                                                            fieldkey: "id",
                                                            fieldname: "name",
                                                            options:
                                                              _vm.filteredCompensatoryNumbers
                                                          },
                                                          model: {
                                                            value:
                                                              item.compensatoryRequestSelected,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "compensatoryRequestSelected",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.compensatoryRequestSelected"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c("span", { staticClass: "color-black" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getItemName(item.selectedType)
                                      ) +
                                      " "
                                  )
                                ])
                          ]
                        ),
                        !_vm.isPeriodFinalized
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-spacing d-flex align-items-center justify-content-end",
                                class: item.saved ? "col-md-3" : "col-md-2"
                              },
                              [
                                item.hasOverrideTeacherSpecialist ||
                                item.hasOverrideAssistanceServiceSpecialist
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column mr-3"
                                      },
                                      [
                                        item.hasOverrideTeacherSpecialist
                                          ? _c("visit-tag", {
                                              attrs: {
                                                color: "green",
                                                icon: "fas fa-user-md",
                                                label: "Reemplazo de Maestro",
                                                type: "green"
                                              }
                                            })
                                          : _vm._e(),
                                        item.hasOverrideAssistanceServiceSpecialist
                                          ? _c("visit-tag", {
                                              attrs: {
                                                color: "orange",
                                                icon: "fas fa-user-md",
                                                label:
                                                  "Reemplazo de Asistente de Servicio",
                                                type: "red"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.enableActionMenu(item) &&
                                !item.enableReplaceSpecialist
                                  ? _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-dropdown-actions dropdown-toggle",
                                          attrs: {
                                            id: "dropdownMenuButton",
                                            "aria-expanded": "false",
                                            "aria-haspopup": "true",
                                            "data-toggle": "dropdown",
                                            type: "button"
                                          }
                                        },
                                        [_vm._v(" Acciones ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dropdown-menu-right custom-dropdown-container",
                                          attrs: {
                                            "aria-labelledby":
                                              "dropdownMenuButton"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item cursor-pointer mb-1",
                                              on: {
                                                click: function($event) {
                                                  return _vm.editVisit(
                                                    item,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "fa fa-pencil text-green pr-1"
                                              }),
                                              _c("span", [
                                                _vm._v("Editar Visita")
                                              ])
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item cursor-pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.onDeleteVisit(
                                                    item.id,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "fa fa-times-circle text-red pr-1"
                                              }),
                                              _c("span", [
                                                _vm._v("Eliminar Visita")
                                              ])
                                            ]
                                          ),
                                          _c("hr", { staticClass: "mt-2" }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item cursor-pointer mt-n2",
                                              on: {
                                                click: function($event) {
                                                  return _vm.replaceServicePlace(
                                                    item,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "fa fa-exchange text-green pr-1"
                                              }),
                                              _c("span", [
                                                _vm._v(
                                                  "Reemplazar Maestro y/o Asistente de Servicios"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.enableActionButton(item)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        (!item.saved && item.id) ||
                                        item.enableReplaceSpecialist
                                          ? _c(
                                              "action-button",
                                              {
                                                staticClass: "px-4 mr-2",
                                                attrs: {
                                                  i: "fas fa-times-circle",
                                                  variant:
                                                    "outline-danger btn-cancel danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onCancelEdit(
                                                      item,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" Cancelar ")]
                                            )
                                          : _vm._e(),
                                        _c("action-button", {
                                          staticClass: "px-4",
                                          attrs: {
                                            i: "fas fa-save",
                                            text: "Guardar",
                                            variant: "success"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleSaveVisit(
                                                item,
                                                item.id,
                                                index
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                item.errors || item.validations
                  ? _c(
                      "div",
                      { staticClass: "visit-error-container" },
                      [
                        _vm._l(item.validations, function(error, errorIndex) {
                          return _c("error", {
                            key: `validation-container-visit` + errorIndex,
                            attrs: { message: error, variant: "no-border" }
                          })
                        }),
                        _vm._l(item.errors, function(error, errorIndex) {
                          return _c("error", {
                            key: `error-container-visit` + errorIndex,
                            attrs: { message: error, variant: "no-border" }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }